import { useEffect, useMemo } from "react";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { isParamNumeric } from "../utils/utils";

export const useGetYouthKidById = (youthKidId: number | string | undefined) => {
  const api = useAPI();
  const { data, error, query } = useAPIQuery({ apiCall: api.youthKidGet });
  useToastOnAPIError({
    error,
    title: `Unable to get youth kid ${youthKidId}`,
  });

  const youthKid = useMemo(() => data?.youthKids[0], [data?.youthKids]);

  useEffect(() => {
    if (typeof youthKidId === "number") {
      query({ id: youthKidId });
    } else if (typeof youthKidId === "string" && isParamNumeric(youthKidId)) {
      query({ id: Number(youthKidId) });
    }
  }, [query, youthKidId]);

  return youthKid;
};
